export default __webpack_public_path__ + "static/media/icon_private_fail_m.dd3a58a6.svg";